<template>
  <ConfirmationModal
    :title="$t('ACCOUNT_BILLING_ADD_FUNDS_HEADER')"
    :show-confirm-button="false"
    :show-cancel-button="false"
    :custom-classes="'add-funds-modal'"
    :allow-modal-to-be-closed="false"
    @close="closeModal"
  >
    <AddFundsForm
      @cancel="closeModal"
    />
  </ConfirmationModal>
</template>

<script>
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import AddFundsForm from './AddFundsForm';

export default {
  name: 'AddFundsModal',
  components: {
    ConfirmationModal,
    AddFundsForm
  },
  methods:{
    closeModal() {
      this.$emit('closeModal');
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>
<style lang="scss">
.add-funds-modal {
  .modal-footer {
    display: none;
  }
}
</style>